<div class="borderMedium" style="display: flex; z-index: 4;">
  <div style="width: 200px;" class="borderMedium">
    <ion-card color="medium" class="margin0 padding5">
      {{locationName}}

      <ion-badge color="medium" mode="ios"
        (click)="clickDashboardNumber([['user.user_pd.'+locationType,locationName], ['user.user_pd.status',null,'is']])"
        *ngIf="countObject.empty_count>0">{{countObject.empty_count}}</ion-badge>
      <ion-badge color="tertiary" mode="ios"
        (click)="clickDashboardNumber([['user.user_pd.'+locationType,locationName], ['user.user_pd.status','Verified']])"
        *ngIf="countObject.verified_count>0">{{countObject.verified_count}}</ion-badge>
      <ion-badge
        (click)="clickDashboardNumber([['user.user_pd.'+locationType,locationName], ['user.user_pd.status','Joined']])"
        color="danger" mode="ios" *ngIf="countObject.joined_count>0">{{countObject.joined_count}}</ion-badge>


      <ion-icon name="chevron-forward" class="floatRight" (click)="arrowUp = !arrowUp" *ngIf="arrowUp"></ion-icon>
      <ion-icon name="chevron-down" class="floatRight" (click)="getChildList()" *ngIf="!arrowUp"></ion-icon>

      <ion-badge *ngFor="let item of dsList" (click)="clickPost(item)" color="primary" mode="ios">{{item.name}} -
        {{item.emp_json.name}}</ion-badge>
      <!-- <ion-row *ngFor="let item of dsList" (click)="clickPost(item)">
        <ion-col size="2" class="borderMedium singleLine"><img [src]="item.emp_json.url" *ngIf="item.emp_json.url">
        </ion-col>
        <ion-col size="6" class="borderMedium singleLine">{{item.emp_json.name}}</ion-col>
        <ion-col size="4" class="borderMedium singleLine">{{item.name}}</ion-col>
      </ion-row> -->
      <br>
      <ion-badge (click)="onClickAddNew('new')" *ngIf="auth.loggedInEmployee.designation && auth.loggedInEmployee.designation.includes('admin')"
        color="secondary" size="small">
        Add Post
      </ion-badge>
    </ion-card>
  </div>
  <div *ngIf="arrowUp">

    <app-designation-location *ngFor="let item of childList" [locationName]="item.name" [countObject]="item.countObject"
      [locationType]="item.type" [parent]="locationName"></app-designation-location>

  </div>
</div>
<div style="margin-top: 30px;">
  <app-user-view style="margin-top: 40px;" [empId]="displayEmployee.id" (closePopup)="displayProfile=false"
    *ngIf="displayProfile"></app-user-view>
</div>